import { tracked } from '@glimmer/tracking';

import FilterSortReport from 'webapp/models-custom/filter-sort/report';

export default class FilterSortReportInList extends FilterSortReport {
	@tracked override viewId = 'table';

	override itemDomSelector = 'tr.table-row';
}
